import { Component, Input, OnChanges } from "@angular/core";

@Component({
  selector: "app-body",
  templateUrl: "./body.component.html",
  styleUrls: ["./body.component.css"]
})
export class BodyComponent implements OnChanges {
  @Input() public arrayData: any[] = [];
  @Input() public arrayLabels: any[] = [];

  public arrayTrimestre: any[];

  constructor() {}

  ngOnChanges() {
    this.getDataInputs();
  }

  private async getDataInputs() {
    this.arrayTrimestre = [];
    try {
      await this.arrayLabels;
      await this.arrayData.forEach(data => {
        this.arrayTrimestre.push(data["label"]);
      });
    } catch (exception) {
      console.log(exception);
    }
  }
}
